export const FATURA_CURRENCY_OPTIONS = [
	{ code: "TRY", symbol: "\u20BA" },
	{ code: "EUR", symbol: "\u20AC" },
	{ code: "USD", symbol: "$" },
];

export const FATURA_KDV_OPTIONS = [0, 1, 8, 10, 18, 20];

const FATURA_CURRENCY_MAP = new Map(
	FATURA_CURRENCY_OPTIONS.map((item) => [item.code, item.symbol]),
);

export function normalizeFaturaCurrency(code) {
	return FATURA_CURRENCY_MAP.has(code) ? code : "TRY";
}

export function getFaturaCurrencySymbol(code) {
	return FATURA_CURRENCY_MAP.get(normalizeFaturaCurrency(code)) || "\u20BA";
}

export function formatFaturaAmount(formatter, value, code) {
	if (value == null || value === "") return "\u2014";
	return `${formatter.format(Number(value))} ${getFaturaCurrencySymbol(code)}`;
}

export function parseFaturaQuantity(value) {
	if (typeof value === "number") {
		return Number.isInteger(value) && value >= 1 ? value : null;
	}

	if (value === null || value === undefined) return null;

	const trimmed = String(value).trim();
	if (!trimmed) return null;

	if (/^\d+$/.test(trimmed)) {
		const parsed = Number.parseInt(trimmed, 10);
		return Number.isInteger(parsed) && parsed >= 1 ? parsed : null;
	}

	if (!/^\d+\.0+$/.test(trimmed)) return null;

	const parsed = Number(trimmed);
	return Number.isInteger(parsed) && parsed >= 1 ? parsed : null;
}

export function normalizeFaturaQuantityInputValue(value, fallback = 1) {
	const parsed = parseFaturaQuantity(value);
	const fallbackValue = parseFaturaQuantity(fallback) ?? 1;
	return String(parsed ?? fallbackValue);
}

export function formatFaturaQuantityDisplay(value, fallback = "\u2014") {
	const parsed = parseFaturaQuantity(value);
	return parsed === null ? fallback : String(parsed);
}

export function roundFaturaAmount(value) {
	if (value === null || value === undefined) return null;
	return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}

export function calculateFaturaTotals({ birimFiyat, birimMiktar, kdvOrani }) {
	const normalizedBirimFiyat =
		birimFiyat === null || birimFiyat === undefined || birimFiyat === ""
			? null
			: (Number.isFinite(Number(birimFiyat)) ? Number(birimFiyat) : null);
	const normalizedBirimMiktar = parseFaturaQuantity(birimMiktar) ?? 1;
	const normalizedKdvOrani = Number.isFinite(Number(kdvOrani)) ? Number(kdvOrani) : 0;

	if (normalizedBirimFiyat === null) {
		return {
			birimMiktar: normalizedBirimMiktar,
			araToplam: null,
			kdvTutar: null,
			satinAlmaDegeri: null,
		};
	}

	const araToplam = roundFaturaAmount(normalizedBirimFiyat * normalizedBirimMiktar);
	const kdvTutar = roundFaturaAmount(araToplam * (normalizedKdvOrani / 100));
	const satinAlmaDegeri = roundFaturaAmount(araToplam + kdvTutar);

	return {
		birimMiktar: normalizedBirimMiktar,
		araToplam,
		kdvTutar,
		satinAlmaDegeri,
	};
}

export function buildFaturaKdvOptions(selected = "") {
	const normalized = selected === null || selected === undefined || selected === "" ? "" : String(Number(selected));
	return FATURA_KDV_OPTIONS.map((option) => {
		const value = String(option);
		return `<option value="${value}"${value === normalized ? " selected" : ""}>${value}%</option>`;
	}).join("");
}
